import React, { Component, PropTypes } from "react";
import { Link } from "react-router/es";
import Navbar from "./Navbar";
import Logo from "assets/img/Sysco-Studio-Logo_white.png";
import UserMenu from "./UserMenu";
import Workflow from "records/Workflow";
import { availableWorkflows } from "constants/workflows";

class Header extends Component {
  static propTypes = {
    workflows: PropTypes.object,
    auth: PropTypes.object,
    userRoutes: PropTypes.array,
    user: PropTypes.object,
    setChangeAccVisibility: PropTypes.func,
    currentBrand: PropTypes.object,
    roleInfo: PropTypes.shape({
      changeAccAllowed: PropTypes.bool,
    }),
    currentPage: PropTypes.number,
    notifications: PropTypes.object,
    syscoProducts: PropTypes.object,
    syscoProductsLoading: PropTypes.bool,
    typeItems: PropTypes.object,
    recentDesigns: PropTypes.object,
    dispatch: PropTypes.func,
    design: PropTypes.object,
    designs: PropTypes.object,
    userData: PropTypes.object,
  };

  renderAuthenticated() {
    const {
      currentBrand,
      typeItems,
      recentDesigns,
      dispatch,
      design,
      designs,
      userData,
      workflows,
      user,
    } = this.props;
    const onboardingFlow = Workflow.getWorkflowByName(
      workflows,
      availableWorkflows.ONBOARDING
    );
    const agreedToLegal = user.get("agreedToLegal");
    let inProgress = false;
    if (onboardingFlow) {
      inProgress = onboardingFlow.isInProgress();
    }

    return (
      <div>
        {!inProgress && agreedToLegal && (
          <div className="header-navigation nav-area">
            <Navbar
              typeItems={typeItems}
              recentDesigns={recentDesigns}
              dispatch={dispatch}
              design={design}
              designs={designs}
              userData={userData}
              currentBrand={currentBrand}
            />
            <div className="restaurant-info">
              {currentBrand.get("brandName")}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      userRoutes,
      workflows,
      user,
      onNavigate,
      setChangeAccVisibility,
      auth,
      roleInfo,
      currentPage,
      notifications,
      syscoProducts,
      syscoProductsLoading,
      dispatch,
      currentBrand,
    } = this.props;
    const onboardingFlow = Workflow.getWorkflowByName(
      workflows,
      availableWorkflows.ONBOARDING
    );
    const agreedToLegal = user.get("agreedToLegal");
    let inProgress = false;
    if (onboardingFlow) {
      inProgress = onboardingFlow.isInProgress();
    }
    const authenticated =
      auth.get("authenticated") || auth.get("adminAuthenticated");
    return (
      <header className="header-section">
        <div className="header-top-bar">
          <Link onClick={onNavigate} className="logo-img">
            <img src={Logo} alt="Sysco" className="logo-float" />
          </Link>
          {agreedToLegal ? (
            <UserMenu
              menuRoutes={userRoutes}
              registerWorkflowInProgress={inProgress}
              setChangeAccVisibility={setChangeAccVisibility}
              roleInfo={roleInfo}
              currentPage={currentPage}
              notifications={notifications}
              syscoProducts={syscoProducts}
              syscoProductsLoading={syscoProductsLoading}
              dispatch={dispatch}
              auth={auth}
              user={user}
              currentBrand={currentBrand}
            />
          ) : null}
        </div>

        {authenticated ? this.renderAuthenticated() : null}
      </header>
    );
  }
}

export default Header;